<template>
    <form>
        <div class="vx-row w-full mb-2" v-if="form.basic_info == null">
            <div class="vs-col mb-2 w-full flex justify-center">
                <span class="mr-2">Empresa Filial?</span>
                <vs-switch class="w-16" v-model="form.parent_company.has" :disabled="isEditingCompany">
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                </vs-switch>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="w-full mb-2" v-if="form.parent_company.has">
                    <div class="m-2"><span>Empresa Matriz</span></div>
                    <vs-select class="w-full select" autocomplete v-model="form.parent_company.parent_id" name="Empresa Matriz" @input-change="searchClients" :disabled="isEditingCompany">
                        <vs-select-item :key="index" v-for="(customer, index) in customers" :text="customer.name" :value="customer.company_id"></vs-select-item>
                    </vs-select>
                </div>
                <div class="w-full mb-2" v-if="form.parent_company.has">
                    <div class="m-2">
                        <span>Deseja replicar os itens na filial?</span>
                        <feather-icon icon="HelpCircleIcon" class="ml-2" v-tooltip="'Esta opção define se os produtos e serviços da matriz serão ou não replicados para a nova filial'"></feather-icon>
                        <vs-switch class="w-16" v-model="form.parent_company.replicate_data" :disabled="isEditingCompany">
                            <span slot="on">Sim</span>
                            <span slot="off">Não</span>
                        </vs-switch>
                    </div>
                </div>
                <div class="flex flex-col w-full mb-2" v-else>
                    <div class="m-2"><span class="text-danger">* </span><span>CPF ou CNPJ</span></div>
                    <vs-input class="w-full" icon-pack="feather" @input="onDocumentInput" @change="(!validaCpfCnpj(form.document_number)) ? form.document_number = '' : null"icon="icon-book" size="large" name="CPF ou CNPJ" v-validate="'required'" v-model="form.document_number" @change.native.stop="validateDocumentNumber"></vs-input>
                    <span class="text-danger text-sm"  v-show="errors.has('CPF ou CNPJ') || !document_number_is_valid">{{ errors.first('CPF ou CNPJ') }}</span>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col w-full mb-2">
                    <div class="m-2"><span class="text-danger">* </span><span>Email</span></div>
                    <vs-input class="w-full" icon-pack="feather" icon="icon-mail" size="large" name="email" v-model="form.contact.email" v-validate="'required|email'" @blur="validateEmail"></vs-input>
                    <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
                    <span class="text-warning text-sm" v-show="emailExists">Já existe uma empresa cadastrada com este email</span>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col w-full mb-2" v-if="!form.parent_company.has">
                    <div class="m-2"><span class="text-danger">* </span><span>Razão social</span></div>
                    <vs-input class="w-full" icon="location_city" size="large" v-validate="'required'" name="razão social" v-model="form.social_name"></vs-input>
                    <span class="text-danger text-sm"  v-show="errors.has('razão social')">{{ errors.first('razão social') }}</span>
                </div>
                <div class="flex flex-col w-full mb-2" v-else>
                    <div class="m-2"><span class="text-danger">* </span><span>CPF ou CNPJ</span></div>
                    <vs-input class="w-full" @input="onDocumentInput" @change="(!validaCpfCnpj(form.document_number)) ? form.document_number = '' : null" icon-pack="feather" icon="icon-book" size="large" name="CPF ou CNPJ" v-validate="'required'" v-model="form.document_number" @change.native.stop="validateDocumentNumber"></vs-input>
                    <span class="text-danger text-sm"  v-show="errors.has('CPF ou CNPJ') || !document_number_is_valid">{{ errors.first('CPF ou CNPJ') }}</span>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col lg:flex-row w-full mb-2">
                    <div class="w-full lg:w-1/2 mr-2">
                        <div class="m-2"><span class="text-danger">* </span><span>Celular/WhatsApp</span></div>
                        <vs-input v-validate="'required'" name="Celular/WhatsApp" class="w-full" icon-pack="feather" icon="icon-smartphone" size="large" v-model="form.contact.phone" v-mask="['(##) # ####-####', '(###) # ####-####']"></vs-input>
                        <span class="text-danger text-sm" v-show="errors.has('Celular/WhatsApp')">{{ errors.first('Celular/WhatsApp') }}</span>
                    </div>
                    <div class="w-full lg:w-1/2">
                        <div class="m-2"><span>Telefone</span></div>
                        <vs-input class="w-full" icon-pack="feather" icon="icon-phone" size="large" v-model="form.contact.telphone" v-mask="['(##) ####-####']"></vs-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col w-full mb-2" v-if="!form.parent_company.has">
                    <div class="m-2"><span class="text-danger">* </span><span>Nome fantasia</span></div>
                    <vs-input class="w-full" icon-pack="feather" icon="icon-user" size="large" name="nome fantasia" v-validate="'required'" v-model="form.fantasy_name"></vs-input>
                    <span class="text-danger text-sm"  v-show="errors.has('nome fantasia')">{{ errors.first('nome fantasia') }}</span>
                </div>
                <div class="flex flex-col w-full mb-2" v-else>
                    <div class="m-2"><span class="text-danger">* </span><span>Razão social</span></div>
                    <vs-input class="w-full" icon="location_city" size="large" v-validate="'required'" name="razão social" v-model="form.social_name"></vs-input>
                    <span class="text-danger text-sm"  v-show="errors.has('razão social')">{{ errors.first('razão social') }}</span>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col lg:flex-row w-full mb-2">
                    <div class="w-full lg:w-1/2 mr-2">
                        <div class="m-2"><span class="text-danger">* </span><span>Cep</span></div>
                        <vs-input class="w-full" icon-pack="feather" icon="icon-hash" size="large" name="cep" v-validate="'required'" v-model="form.address.zip" @input="searchCepData" v-mask="['#####-###']"></vs-input>
                        <span class="text-danger text-sm"  v-show="errors.has('cep')">{{ errors.first('cep') }}</span>
                    </div>
                    <div class="w-full lg:w-1/2">
                        <div class="m-2"><span class="text-danger">* </span><span>Bairro</span></div>
                        <vs-input class="w-full" icon-pack="feather" icon="icon-home" size="large" name="bairro" v-validate="'required'" v-model="form.address.neighborhood"></vs-input>
                        <span class="text-danger text-sm"  v-show="errors.has('bairro')">{{ errors.first('bairro') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col w-full mb-2" v-if="!form.parent_company.has">
                    <div class="m-2"><span>Inscrição estadual</span></div>
                    <vs-input class="w-full" icon-pack="feather" icon="icon-hash" size="large" v-model="form.fiscal.ie"></vs-input>
                </div>
                <div class="flex flex-col w-full mb-2" v-else>
                    <div class="m-2"><span class="text-danger">* </span><span>Nome fantasia</span></div>
                    <vs-input class="w-full" icon-pack="feather" icon="icon-user" size="large" name="nome fantasia" v-validate="'required'" v-model="form.fantasy_name"></vs-input>
                    <span class="text-danger text-sm"  v-show="errors.has('nome fantasia')">{{ errors.first('nome fantasia') }}</span>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col lg:flex-row w-full mb-2">
                    <div class="w-full lg:w-2/3 mr-2">
                        <div class="m-2"><span class="text-danger">* </span><span>Rua</span></div>
                        <vs-input class="w-full" icon-pack="feather" icon="icon-hash" size="large" name="rua" v-validate="'required'" v-model="form.address.street"></vs-input>
                        <span class="text-danger text-sm"  v-show="errors.has('rua')">{{ errors.first('rua') }}</span>
                    </div>
                    <div class="w-full lg:w-1/3">
                        <div class="m-2"><span class="text-danger">* </span><span>Número</span></div>
                        <vs-input class="w-full" icon-pack="feather" icon="icon-home" size="large" name="numero" v-validate="'required'" v-model="form.address.number"></vs-input>
                        <span class="text-danger text-sm"  v-show="errors.has('numero')">{{ errors.first('numero') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col w-full mb-2" v-if="!form.parent_company.has">
                    <div class="m-2"><span>Inscrição municipal</span></div>
                    <vs-input class="w-full" icon-pack="feather" icon="icon-hash" size="large" v-model="form.fiscal.im" name="inscrição municipal"></vs-input>
                </div>
                <div class="flex flex-col w-full mb-2" v-else>
                    <div class="m-2"><span>Inscrição estadual</span></div>
                    <vs-input class="w-full" icon-pack="feather" icon="icon-hash" size="large" v-model="form.fiscal.ie"></vs-input>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex w-full mb-2">
                    <div class="w-full">
                        <div class="m-2"><span>Complemento</span></div>
                        <vs-input class="w-full" icon-pack="feather" size="large" v-model="form.address.complement"></vs-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col lg:flex-row w-full mb-2" v-if="!form.parent_company.has">
                    <div class="w-full lg:w-1/5 mb-2">
                        <div class="m-2"><span>ISS retido?</span></div>
                        <vs-switch class="w-16 mt-2" v-model="form.fiscal.iss_retido">
                            <span slot="on">Sim</span>
                            <span slot="off">Não</span>
                        </vs-switch>
                    </div>
                    <div class="w-full lg:w-4/5 mb-2">
                        <div class="m-2"><span class="text-danger">* </span><span>Fiscal CRT</span></div>
                        <vs-radio class="w-full" v-model="form.fiscal.fiscal_crt" :vs-value="crt.id" v-for="(crt, index) in crts" :key="index" v-validate="'required'" name="fiscal CRT" >{{crt.name}}</vs-radio>
                        <span class="text-danger text-sm"  v-show="errors.has('fiscal CRT')">{{ errors.first('fiscal CRT') }}</span>
                    </div>
                </div>
                <div class="flex flex-col w-full mb-2" v-else>
                    <div class="m-2"><span>Inscrição municipal</span></div>
                    <vs-input class="w-full" icon-pack="feather" icon="icon-hash" size="large" v-model="form.fiscal.im" name="inscrição municipal"></vs-input>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col lg:flex-row w-full mb-2">
                    <div class="w-full lg:w-1/2 mr-2">
                        <div class="m-2"><span class="text-danger">* </span><span>Estado</span></div>
                        <vs-select class="w-full select" placeholder="Estado" v-model="form.address.region" name="estado" v-validate="'required'" :danger="errors.has('estado')" @change="getCities">
                            <vs-select-item :key="index" v-for="(region, index) in regions" :text="region.estado" :value="region.uf"></vs-select-item>
                        </vs-select>
                    </div>
                    <div class="w-full lg:w-1/2">
                        <div class="m-2"><span class="text-danger">* </span><span>Cidade</span></div>
                        <vs-select size="large" class="w-full select" v-model="form.address.city" name="cidade" v-validate="'required'" :danger="errors.has('cidade')" @change="setCityIbgeCode">
                            <vs-select-item :key="index" v-for="(city, index) in cities" :text="city.nome" :value="city.nome"></vs-select-item>
                        </vs-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col lg:flex-row w-full mb-2" v-if="form.parent_company.has">
                    <div class="w-full lg:w-1/5 mb-2">
                        <div class="m-2"><span>ISS retido?</span></div>
                        <vs-switch class="w-16 mt-2" v-model="form.fiscal.iss_retido">
                            <span slot="on">Sim</span>
                            <span slot="off">Não</span>
                        </vs-switch>
                    </div>
                    <div class="w-full lg:w-4/5 mb-2">
                        <div class="m-2"><span class="text-danger">* </span><span>Fiscal CRT</span></div>
                        <vs-radio class="w-full" v-model="form.fiscal.fiscal_crt" :vs-value="crt.id" v-for="(crt, index) in crts" :key="index" v-validate="'required'" name="fiscal CRT" >{{crt.name}}</vs-radio>
                        <span class="text-danger text-sm"  v-show="errors.has('fiscal CRT')">{{ errors.first('fiscal CRT') }}</span>
                    </div>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex w-full mb-2">
                    <div class="w-full">
                        <div class="m-2"><span>Observação</span></div>
                        <vs-input class="w-full" size="large" icon-pack="feather" icon="icon-hash" v-model="form.obs"></vs-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="flex flex-col w-full mb-2">
                    <div class="m-2"><span>Pontos de acesso ao Sistema (computadores) ?</span></div>
                    <vs-input-number class="w-32" v-model="form.computer_quantity"/>
                </div>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
            </div>
        </div>
    </form>
</template>

<script>
import {consultarCEP} from "../../helpers/utils";
export default {
    props: {
        company: Object,
        isEditingCompany: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            form: {
                computer_quantity: 0,
                fantasy_name: '',
                social_name: '',
                document_number: '',
                parent_company: {
                    has: false,
                    parent_id: '',
                    replicate_data: true
                },
                address: {
                    zip: '',
                    neighborhood: '',
                    street: '',
                    number: '',
                    city: '',
                    region: '',
                    country_code: 1058,
                    complement: ''
                },
                contact: {
                    email: '',
                    telphone: '',
                    phone: ''
                },
                fiscal: {
                    iss_retido: false
                }
            },
            emailExists: false,
            document_number: '',
            document_number_is_valid: true,
            regions: [],

            cities: [],

            crts: [
                {name: 'Simples Nacional', id: 1},
                {name: 'Simples Nacional - excesso de sublimite da receita bruta', id: 2},
                {name: 'Regime Normal', id: 3},
                {name: 'SIMEI', id: 4},
            ],

            customers: []
        }
    },
    methods: {
        validateEmail({target: {value}}) {
            this.$axios.get(`company/exists/email/${value}`).then(({data}) => {
                this.emailExists = data.exists;
            })
        },

        async validateForm () {
            return await this.$validator.validateAll().then(result => {
                return !this.errors.any()
            })
        },

        async checkIfDocumentExistsInDataBase(document_number) {
            try {
                this.$emit("loading", true);

                const normalizedDocument = String(document_number)
                    .toUpperCase()
                    .replace(/[^A-Z0-9]+/g, '');

                const { data } = await this.$axios.get(
                    `company/exists/cpf_cnpj/${normalizedDocument}`
                );

                return data.exists;
            } catch (Err) {
                this.$emit("loading", false);
            }
        },

        async loadDocumentNumberInfo (document_number) {
            this.$emit("loading", true);
            await this.$axios.get(`consulta/exterior/${document_number}`, {timeout: 5000}).then(({data})=> {
                if (data.status !== "ERROR") {
                    this.form.fantasy_name = data.fantasia;
                    this.form.social_name = data.nome;
                    this.form.email = data.email;
                    this.form.contact.telphone = data.telefone.replace(/\D/g,'');
                    this.form.address.street = data.logradouro;
                    this.form.address.zip = data.cep || this.form.address.zip;
                    this.form.address.number = data.numero;
                } else {
                    this.$vs.notify({
                        text: data.message,
                        color:'danger',
                        time: 5000
                    });
                    this.errors.add({
                        field: 'CPF ou CNPJ',
                        scope: this.$options.scope,
                        msg: data.message
                    });
                }
                this.$emit("loading", false);
            }).catch((err)=>{
                this.$emit("loading", false);
                this.$vs.notify({
                    text: "Preenchimento automático não pôde ser realizado.",
                    color:'warning',
                    time: 5000
                });
            })
        },
        async validateDocumentNumber ({target}) {
            if (target.value < 18 || this.form.document_number === this.document_number) {
                return;
            }

            const document_number = target.value
                .toUpperCase()
                .replace(/[^A-Z0-9]+/g, '');

            if (!document_number) {
                return;
            }

            if (document_number.length > 11) {
                this.loadDocumentNumberInfo(document_number);
            } else {
                this.$emit('loading', false);
            }
        },

        async getRegions () {
            const {data} = await this.$axios.get("consulta/regions");
            this.regions = data;
        },

        async getCities () {
            const id_estado = this.regions.find(uf => uf.uf === this.form.address.region).id_estado;
            const {data} = await this.$axios.get(`consulta/regions/${id_estado}/cities`);
            this.cities = data;
            this.form.address.region_code = this.regions.filter(region => region.uf == this.form.address.region)[0].codigo_ibge;
        },

        setCityIbgeCode () {
            const cidade = this.cities.find(cidade => this.form.address.city == cidade.nome)

            if (cidade) {
               this.form.address.city_code = cidade.codigo_ibge;
            }
        },

        async validateForm () {
            if (!this.document_number_is_valid) {
                return false;
            }
            return await this.$validator.validateAll().then(result => {
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        },

        getForm () {
            return {...this.form, fiscal: {...this.form.fiscal, iss_retido: this.form.fiscal.iss_retido === true ? 1 : 2}};
        },

        formatCpfCnpj(value) {
            let doc = String(value || '')
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, '');

            // Tem letra -> CNPJ alfanumérico
            if (/[A-Z]/.test(doc)) {
                doc = doc.substring(0, 14);

                return doc
                    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
                    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
                    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3/$4')
                    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})([0-9]{0,2}).*$/, '$1.$2.$3/$4-$5');
            }

            // Até 11 dígitos = CPF
            if (doc.length <= 11) {
                doc = doc.substring(0, 11);

                return doc
                    .replace(/^(\d{3})(\d)/, '$1.$2')
                    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
                    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
            }

            // CNPJ numérico
            doc = doc.substring(0, 14);

            return doc
                .replace(/^(\d{2})(\d)/, '$1.$2')
                .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
                .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
                .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
        },

        validaCPF(cpf) {
            cpf = String(cpf).replace(/\D/g, '');

            if (cpf.length !== 11) {
                return false;
            }

            if (/^(\d)\1{10}$/.test(cpf)) {
                return false;
            }

            let soma = 0;

            for (let i = 0; i < 9; i++) {
                soma += Number(cpf[i]) * (10 - i);
            }

            let dv1 = 11 - (soma % 11);

            if (dv1 > 9) {
                dv1 = 0;
            }

            if (dv1 !== Number(cpf[9])) {
                return false;
            }

            soma = 0;

            for (let i = 0; i < 10; i++) {
                soma += Number(cpf[i]) * (11 - i);
            }

            let dv2 = 11 - (soma % 11);

            if (dv2 > 9) {
                dv2 = 0;
            }

            return dv2 === Number(cpf[10]);
        },

        validaCNPJ(cnpj) {
            cnpj = String(cnpj)
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, '');

            if (cnpj.length !== 14) {
                return false;
            }

            if (/^([A-Z0-9])\1{13}$/.test(cnpj)) {
                return false;
            }

            const pesosDV1 = [5,4,3,2,9,8,7,6,5,4,3,2];
            const pesosDV2 = [6,5,4,3,2,9,8,7,6,5,4,3,2];

            function valorCaractere(char) {
                return char.charCodeAt(0) - 48;
            }

            function calcularDV(base, pesos) {
                let soma = 0;

                for (let i = 0; i < pesos.length; i++) {
                    soma += valorCaractere(base[i]) * pesos[i];
                }

                const resto = soma % 11;

                return resto < 2
                    ? 0
                    : 11 - resto;
            }

            const base = cnpj.substring(0, 12);
            const dvInformado = cnpj.substring(12);

            const dv1 = calcularDV(base, pesosDV1);
            const dv2 = calcularDV(base + dv1, pesosDV2);

            return dvInformado === `${dv1}${dv2}`;
        },

        validaCpfCnpj(documento) {
            const normalizado = String(documento)
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, '');

            if (/^\d{11}$/.test(normalizado)) {
                return this.validaCPF(normalizado);
            }

            if (normalizado.length === 14) {
                return this.validaCNPJ(normalizado);
            }

            return false;
        },

        onDocumentInput(value) {
            this.form.document_number = this.formatCpfCnpj(value);
        }
    },

    async created() {
        this.searchCepData = _.debounce(async (q) => {
            if (q.length <=0) {
                return;
            }
            const data = await consultarCEP(q);
            if (data) {
                this.form.address.region = data.uf;
                this.form.address.city = data.localidade;
                this.form.address.city_code = data.ibge;
                this.form.address.neighborhood = data.bairro;
                this.form.address.street = data.logradouro || this.form.address.street;
            }
        }, 500);

        this.searchClients = _.debounce(async ({target: {value: name}}) => {
            this.customers = [];
            if (name) {
                const {data} = await this.$axios.get(`company/q/byName?nome=${name}`);
                if (data) {
                    this.customers = data.data.map(cp => ({name: cp.company.fantasy_name, company_id: cp.company.id_company}));
                }
            }
        }, 600);

        this.form = this.company ? {...this.company, fiscal: {...this.company.fiscal, iss_retido: this.company.fiscal.iss_retido === 1 ? true : false}} : this.form;
        this.document_number = this.form.document_number;
        await this.getRegions();
        if (this.form.address.region) {
            await this.getCities();
            this.form.address.city = this.form.address.city;
        }

        if (this.form.parent_company.parent_id) {
            const {data} = await this.$axios.get(`company/${this.form.parent_company.parent_id}`);
            if (data.data) {
                this.customers = [{name: data.data.company.fantasy_name, company_id: data.data.company.id_company}];
            }
        }
    },
}
</script>

<style>

</style>
